import MaskUtils from 'commons/utils/maskUtils';
import NumberUtils from 'commons/utils/numberUtils';
import PhoneUtils from 'commons/utils/phoneUtils';
import { LOCALE_PT_BR } from './localeConstants';

let selectedLocale = LOCALE_PT_BR;

export function setLocale(newSelectedLocale) {
  selectedLocale = newSelectedLocale ?? LOCALE_PT_BR;
  // ADJUST ALL HELPERS
  PhoneUtils.setLocale(newSelectedLocale);
  NumberUtils.setLocale(newSelectedLocale);
  MaskUtils.setLocale(newSelectedLocale);
}

export function getLocale() {
  // ADJUST ALL HELPERS
  return selectedLocale;
}

export function isLocalePTBR() {
  return !selectedLocale || selectedLocale === LOCALE_PT_BR;
}
